import React from "react";
import "./TextBlock.css";
import { useVisibilityTracker } from "../../../utils/visibilityTracker";

export function ReadAlso({
    jsonData,
    showDigits,
    showReadAlso,
    withBackground,
    showBorders,
    useMargin,
    objectId,
    showId,
}) {
    if (!jsonData || jsonData.length === 0) {
        return null;
    }
    return (
        <ul
            className={`news-list ${showBorders ? "news-list--with-borders" : ""}
        ${withBackground ? "news-list--with-background" : ""}
        ${useMargin ? "news-list--with-margin" : ""}`}
        >
            {showReadAlso && <h2>Читайте также</h2>}
            {jsonData.map((item, index) => {
                const visibilityRef = useVisibilityTracker(
                    item.id,
                    objectId,
                    "ReadAlso",
                    jsonData.length,
                    showId,
                    item.cid,
                    item.crid,
                    item.bidder_id,
                    item.bidder_cid,
                    item.eventtrackers,
                    item
                );
                return (
                    <li key={item.id} className="news-list__item" ref={visibilityRef}>
                        <a href={item.url} target="_blank">
                            {showDigits && <span className="news-list__index">{index + 1}</span>}
                            <span className="news-list__text">{item.title}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}
